"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplicationContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useAuth_1 = __importDefault(require("../hooks/useAuth"));
const initialState = {
    token: '',
    user: {},
    tenant: '',
    setTenant: () => { },
    currentTab: '',
    setCurrentTab: () => { },
    signIn: () => __awaiter(void 0, void 0, void 0, function* () { }),
    signOut: () => { },
    tableFilters: {},
    setTableFilters: () => { },
    isLoggedIn: false,
    errorData: null,
};
const ApplicationContext = (0, react_1.createContext)(initialState);
const ApplicationContextProvider = ({ children }) => {
    const { token, user, isLoggedIn, signIn, signOut, errorData } = (0, useAuth_1.default)();
    const [tenant, setTenant] = (0, react_1.useState)(initialState.tenant);
    const [currentTab, setCurrentTab] = (0, react_1.useState)(initialState.currentTab);
    const [tableFilters, setTableFilters] = (0, react_1.useState)(initialState.tableFilters);
    const contextValue = (0, react_1.useMemo)(() => ({
        token,
        user,
        tenant,
        setTenant,
        currentTab,
        setCurrentTab,
        signIn,
        signOut,
        tableFilters,
        setTableFilters,
        isLoggedIn,
        errorData,
    }), [token, user, tenant, currentTab, isLoggedIn, tableFilters, errorData]);
    return ((0, jsx_runtime_1.jsx)(ApplicationContext.Provider, Object.assign({ value: contextValue }, { children: children })));
};
const useApplicationContext = () => (0, react_1.useContext)(ApplicationContext);
exports.useApplicationContext = useApplicationContext;
exports.default = ApplicationContextProvider;
